// extracted by mini-css-extract-plugin
export default {"button":"Button_button__LmHuF","primary":"Button_primary__NEmQJ","secondary":"Button_secondary__gDyIt","cancel":"Button_cancel__jrkjK","approve":"Button_approve__N7dZ6"};